export default "/images/img-ecommerce.svg?6611341f0117c31b6ae22670b0aa08dc";